import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';
import { Categoria, ProcesoBase, ProcesoCategoria, TramiteBase, TramiteProceso } from '@app/shared';
import { Logger, EndpointService } from '@app/core';

const log = new Logger('SelectTramiteService');

@Injectable()
export class SelectTramiteDuplicateService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) {}

  /**
   * Retorna las categorias asociadas a los tramites por default.
   *
   * @param {boolean} [validUser=false] - Para realizar la consulta validando por usuario
   * @returns {Observable<Categoria[]>}
   * @memberof SelectTramiteDuplicateService
   */
  getCategories(validUser: boolean = false): Observable<Categoria[]> {
    return new Observable(obs => {
      let endPoint = 'category';
      if (validUser) {
        endPoint = 'categoryUser';
      }
      this.http.get<Categoria[]>(this.api.get(endPoint)).subscribe(
        categories => {
          obs.next(categories);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Retorna las procesos asociados a los tramites por default.
   * Dichos procesos son filtrados con el id de la categoria.
   *
   * @param {number} idCategoria
   * @param {boolean} [validUser=false] - Para realizar la consulta validando por usuario
   * @returns {Observable<ProcesoBase[]>}
   * @memberof SelectTramiteDuplicateService
   */
  getProcess(idCategoria: number, validUser: boolean = false): Observable<ProcesoBase[]> {
    return new Observable(obs => {
      if (validUser) {
        this.http.get<ProcesoBase[]>(this.api.get('processUser', [idCategoria])).subscribe(
          data => {
            obs.next(data);
          },
          err => {
            obs.error(err);
          }
        );
      } else {
        this.http.get<ProcesoCategoria>(this.api.get('processCategory', [idCategoria])).subscribe(
          data => {
            obs.next(data.procesos);
          },
          err => {
            obs.error(err);
          }
        );
      }
    });
  }

  /**
   * Retorna los tramites por default sin las actividades.
   * Dichos tramites son filtrados por el id del preceso.
   *
   * @param {number} idProceso
   * @param {boolean} [validUser=false] - Para realizar la consulta validando por usuario
   * @returns {Observable<TramiteBase[]>}
   * @memberof SelectTramiteDuplicateService
   */
  getDefaultTrtamites(idProceso: number, validUser: boolean = false, isModuleBasic: boolean = false): Observable<TramiteBase[]> {
    return new Observable(obs => {
      let endPoint = 'tramiteProcess';
      if (validUser) {
        endPoint = 'tramiteUserProcess';
      }
      if(isModuleBasic){
        endPoint = 'tramiteGenericProcess';
      }
      this.http.get<TramiteProceso>(this.api.get(endPoint, [idProceso])).subscribe(
        data => {
          obs.next(data.tramites);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

   /**
   * Retorna los tramites por default genericos del sistema.
   *
   * @returns {Observable<TramiteBase[]>}
   * @memberof SelectTramiteDuplicateService
   */
   getDefaultGeneric(): Observable<TramiteBase[]> {
    return new Observable(obs => {
      this.http.get<TramiteBase[]>(this.api.get('adminGeneric')).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }
} // End class



// WEBPACK FOOTER //
// ./src/app/shared/select-tramite-duplicate/select-tramite-duplicate.service.ts